<template>
<div class="container">
  <div class="container-box">
    <div class="teacher-panle">
      <div v-if="masterInfo.wxQrCode" class="teacher-wxCode-info-box">
        <div class="teacher-wxCode-box">
          <img class="teacher-wxCode" :src="masterInfo.wxQrCode"/>
          <p class="teacher-wxCode-tip">扫码即可添加好友～</p>
        </div>
      </div>
      <div class="teacher-info-box">
        <div class="teacher-head-box">
          <img class="teacher-head" :src="masterInfo.headImage || currMastertHead "/>
          <p v-if="masterInfo.name" class="teacher-name">{{masterInfo.name}} </p>
          <p v-if="!masterInfo.name" class="teacher-name">班主任分配中</p>
          <p v-if="masterInfo.wxCode" class="teacher-wx">{{masterInfo.wxCode}}</p>
          <p v-if="!masterInfo.wxCode" class="teacher-name">敬请期待～</p>
          <div class="copy-btn"
              v-clipboard:copy="masterInfo.wxCode"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError">
              <span>复制微信号</span>
              <i class="iconfont iconsanjiao"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="class-info">
      <div class="class-info-box">
        <div class="class-info-course-title">
          <i class="iconfont iconshu"></i>
          <h5 class="class-info-name">{{courseStageInfo.courseStageName}}</h5>
        </div>
        <div class="class-info-course-time">
          <i class="iconfont iconclock"></i>
          <h5 class="class-info-name">{{courseStageInfo.weChatScheduleDescription}}</h5>
        </div>
      </div>
    </div>
    <h5 class="thinking-class-detail top-24">课程须知</h5>
      <ul class="thinking-class-mulu-parent">
        <li>
          <h3 class="title"><span class="icon"/>上课形式</h3>
          <p class="content">每周固定时间上课，固定老师，固定班主任。由于是班课，错过课程仍会扣除课时，可查看课程回放补课。</p>
        </li>
        <li>
          <h3 class="title"><span class="icon"/>社群服务</h3>
          <p class="content">请务必添加数学班主任微信，开课前数学班主任将邀请您进入学习群，群内将不定时分享学习资料。</p>
        </li>
        <li>
          <h3 class="title"><span class="icon"/>问题咨询</h3>
          <p class="content">有任何疑问，可与数学班主任微信联系。</p>
        </li>
      </ul>
  </div>
</div>
</template>

<script>
import cookie from 'js-cookie'
import { getStudentCourseDetail } from '@/api/account'
let currMastertHead = require('@/assets/img/account/default-head1.png')
export default {
  data () {
    return {
      masterInfo: {},
      courseStageInfo: {},
      courseStageId: null,
      studentId: null,
      currMastertHead
    }
  },
  created () {
    this.studentId = this.$route.query.studentId || cookie.get('mbstudentid')
    this.courseStageId = this.$route.params.courseStageId
    console.log('info:', this.courseStageId, this.studentId)

    getStudentCourseDetail({
      studentId: this.studentId,
      courseStageId: this.courseStageId
    }).then(res => {
      if (res.code === 200) {
        this.masterInfo = res.data.master || []
        this.courseStageInfo = res.data.courseStage || []
      }
    })
  },
  components: {},
  methods: {
    onCopy () {
      this.$toast('复制成功')
    },
    onError () {
      this.$toast('复制失败,您的手机不支持复制功能')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background:#EFEFEF;
  padding-top: 41px;
  .container-box {
    width: 680px;
    margin: 0 auto;
    .teacher-panle {
      display: flex;
      width: 680px;
      margin-bottom: 41px;
      background: url('~@/assets/img/master/master-info-bk.png') no-repeat;
      background-size:100% 100%;
      .teacher-wxCode-info-box{
        width: 50%;
        .teacher-wxCode-box{
          margin: 92px 0 21px 78px;
          .teacher-wxCode {
            width: 174px;
            height: 174px;
            margin-bottom: 21px;
          }
          .teacher-wxCode-tip {
            height:22px;
            font-size:23px;
            font-weight:bold;
            color:rgba(255,255,255,1);
          }
        }

      }
      .teacher-info-box {
        width: 50%;
        .teacher-head-box {
          margin: 43px 70px 17px 0;
          .teacher-head {
            width: 140px;
            height: 140px;
            margin-left: 110px;
            border-radius: 50% 50%;
          }
          .teacher-name {
            width:183px;
            height:30px;
            font-size:26px;
            font-weight:bold;
            color:rgba(255,255,255,1);
            text-align: center;
            margin: 11px 0 0 87px;
            overflow: hidden;
          }
          .teacher-wx {
            width:183px;
            font-size:26px;
            font-weight:bold;
            color:rgba(255,255,255,1);
            text-align: center;
            margin: 7px 0 0 87px;
            overflow: hidden;
          }
          .copy-btn {
            width:166px;
            height:45px;
            background:linear-gradient(-30deg,rgba(248,85,22,1),rgba(255,151,50,1));
            border-radius:22px;
            margin: 10px 0 0 92px;
            text-align: center;
            span {
              display: inline-block;
              font-weight:bold;
              font-size: 24px;
              color: #fff;
              padding: 9px 0 20px;
              border-radius: 18px;
              line-height:30px;
            }
            .iconsanjiao{
              color:#fff;
              padding-left: 4px;
            }
          }
        }

      }
    }
    .thinking-class-detail {
      width: 680px;
      color: #333;
      font-size: 36px;
      font-weight: bold;
      &.top-24 {
        font-size:30px;
        font-weight:bold;
        color:rgba(127,125,125,1);
        line-height:54px;
        margin-bottom: 36px;
      }
    }
    .thinking-class-mulu-parent {
      width: 680px;
      background-color: #fff;
      border-radius: 16px;
      padding: 0px 32px 40px 32px;
      .title {
        width: 100%;
        color: #333;
        font-size: 27px;
        font-weight: bold;
        padding-top: 25px;
        padding-bottom: 16px;
      }
      .content {
        width: 100%;
        color: #333;
        font-size: 24px;
        line-height: 43px;
        padding-left: 20px;
      }
      .icon {
        width:18px;
        height:18px;
        background: #f85415;
        display: inline-block;
        border-radius: 50%;
        margin-right: 3px;
      }
    }
    .class-info {
      margin-bottom: 39px;
      width: 680px;
      background: #FFFFFF;
      border-radius: 16px;
      .class-info-box {
        padding: 43px 0 43px 15px;
        .class-info-course-time, .class-info-course-title {
          @include flexBox($align: flex-start);
        }
        .class-info-course-title {
          margin-bottom:24px;
        }
        .class-info-name {
          padding-left: 13px;
          font-size:28px;
          font-weight:bold;
          color:rgba(51,51,51,1);
          line-height:40px;
        }
        .iconshu, .iconclock{
          color:#f85415;
          font-size:35px;
          margin-top: 5px;

        }
      }

    }
  }
}

</style>
